import { RECAPTCHA_SITE_KEY } from '../constants/auth';
import React from 'react';
import Recaptcha from 'react-grecaptcha';

const expiredCallback = (token: any) => {
    // console.log(token);
};
const Component = ({ callback }: { callback: any }) => {
    return <Recaptcha sitekey={RECAPTCHA_SITE_KEY} callback={callback} expiredCallback={expiredCallback} invisible />;
};

Component.displayName = 'Recaptcha';

export default Component;
